// Bank statement ingestion status: chip labels and URL params.

/** Figma's 4 chips plus `Unsupported File` (a format failure) — no `Enter Password` / `Truncated File` chip. */
export const INGESTION_CHIP = {
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    DATA_EXTRACTED: 'Data Extracted',
    FAILED: 'Failed',
    UNSUPPORTED_FILE: 'Unsupported File',
} as const;
export type IngestionChip = (typeof INGESTION_CHIP)[keyof typeof INGESTION_CHIP];

/** Hover copy for the trailing chip ⓘ. `Failed` and `Unsupported File` use the doc's own `ingestionReason` instead. */
export const CHIP_TOOLTIP_TEXT = {
    [INGESTION_CHIP.PENDING]: 'Data extraction is pending for this file',
    [INGESTION_CHIP.IN_PROGRESS]: 'Data extraction is in progress for this file',
    [INGESTION_CHIP.DATA_EXTRACTED]: 'Data has been extracted for this file',
} as const;

/** Data Room URL params: doc-type filter (comma-joined directoryMap ids) and Review Now expansion. */
export const DATA_ROOM_URL_PARAMS = {
    DOC_TYPES: 'docTypes',
    /** "1" ⇒ account folders with a Failed file start open. */
    EXPAND_FAILED: 'expandFailed',
} as const;

/** directoryMap id of the Bank Statements folder, used by the filter and the Review Now link. */
export const BANK_STATEMENTS_DOC_TYPE_ID = 'Bank Statements';
